import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';
import { AtLeastAdvisorRoleGuard } from '@next/core-lib/authorization';
import { LocationGuard } from '@next/core-lib/relationships';

import { Observable } from 'rxjs';

import { CreateFeedAdviceComponent } from './components/create-feed-advice/create-feed-advice.component';
import { CreateFeedAdviceFromReferenceComponent } from './components/create-feed-advice-from-reference/create-feed-advice-from-reference.component';
import { FeedAdviceDetailComponent } from './components/feed-advice-detail/feed-advice-detail.component';
import { FeedAdviceOverviewComponent } from './components/feed-advice-overview/feed-advice-overview.component';
import { FeedAdviceOverviewResolver } from './resolvers/feed-advice-overview.resolver';

export const FeedAdviceRoutes = (isReferenceFeedAdvice: boolean): Routes => [
  {
    path: '',
    component: FeedAdviceOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    data: { isReferenceFeedAdvice },
    resolve: {
      data: mapToResolve<Observable<boolean>>(FeedAdviceOverviewResolver),
    },
  },
  {
    path: 'from-reference',
    component: CreateFeedAdviceFromReferenceComponent,
    data: { name: 'create-feed-advice-from-reference' },
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
  },
  {
    path: 'create/:feedAdviceType',
    component: CreateFeedAdviceComponent,
    data: { isReferenceFeedAdvice },
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
  },
  {
    path: 'edit/:id',
    component: FeedAdviceDetailComponent,
    data: { isReferenceFeedAdvice },
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
  },
  {
    path: 'view/:id',
    component: FeedAdviceDetailComponent,
    data: { isReferenceFeedAdvice },
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
  },
];
